export default __webpack_public_path__ + "static/media/greystar.8bee83e6.svg";